export type Row = Record<string, string>;

export type Token = {
  token: string;
};

export type BaseApiResponseT<T> = {
  isSuccess: boolean;
  isFailure: boolean;
  value: T;
  error: {
    code: string;
    message: string;
  };
  errors: string[];
};

export type ContactProps = {
  name: string | undefined;
  phone1?: string | null;
  extension1?: string | null;
  phone2?: string | null;
  extension2?: string | null;
  email?: string | null | undefined;
  fax?: string | null;
  accountingGroup?: string;
  phone1Ext?: number | null;
  userName?: string | null;
  office?: string | null;
  type?: string | null;
};

export type V3MessageData = {
  type: string;
};

export enum ReassignTypeEnum {
  CoveredBy = 'COVERED BY',
  AssignedTo = 'ASSIGNED TO',
  CapacityOpsRep = 'CAPACITY OPS REP',
}

export type CategoryT = {
  title: string;
  slug: string;
  categoryKey: string;
};

export enum OwnershipSource {
  Atg = 0,
  Vendor = 1,
}

export type LoadInputProps = {
  dataTestId: string;
  class: string;
  spinner: number;
};

// SearchField types
import { MenuItemType } from '@components/Select';
import { autoCompleteMap } from '@components/Header/search/constants';
import { Accessor } from 'solid-js';

export type SearchCategoryInternal = 'Load' | keyof typeof autoCompleteMap;

export const MOBILE_CATEGORIES = [
  'Load',
  'Reference #',
  'Shipment Metadata',
  'Carrier',
  'Customer',
  'Tracking #',
  'Phone #',
  'Pro #',
];

export interface SearchFieldProps {
  variant?: 'desktop' | 'mobile';
  onClose?: () => void;
  isHome?: boolean;
}

export interface SearchBodyProps {
  isMobile: boolean;
  selectedCategory: Accessor<SearchCategoryInternal>;
  text: Accessor<string | undefined>;
  setText: (v: string | undefined) => void;
  clearSearch: Accessor<boolean>;
  setClearSearch: (v: boolean) => void;
  isLoading: Accessor<boolean>;
  setSearchError: (v: string | null) => void;
  menuItems: Accessor<MenuItemType[]>;
  handleChange: (value: string) => void;
  handleLoadSearch: () => Promise<void>;
  onClose?: () => void;
}
